import React, { useEffect, useState } from 'react'
import { Box, Stack, Typography } from "@mui/material"
import { Sidebar, Videos } from './'
import { fetchApi } from "../utils/fetchApi"
const Feed = () => {
  const [selectedCategory, setSlectedCategory] = useState("New")
  const [videos, setVideos] = useState([])
  // console.log(videos)
  useEffect(() => {
    fetchApi(`search?part=snippet&q=${selectedCategory}`)
      .then((data) => {
        // console.log("data",data)
        setVideos(data.items)
      })
  }, [selectedCategory])
  return (
    <Stack sx={{
      flexDirection: {
        sx: "column", md: "row"
      }
    }}>
      <Box sx={{
        height: { sx: "auto", md: "92vh" },
        borderRight: "1px solid #3d3d3d", px: { sx: 0, md: 2 }
      }}>
        <Sidebar selectedCategory={selectedCategory} setSlectedCategory={setSlectedCategory} />
        <Typography className='copyright' variant='body2' sx={{ mt: 1.5, color: "#fff" }}>
          copywrite
        </Typography>
      </Box>
      <Box p={2} sx={{ overflowY: "auto", height: "90vh", flex: 2 }}>
        <Typography variant='="h4' fontWeight="bold" mb={2} sx={{ color: "white" }}>
          {selectedCategory} <span
            style={{
              color: "#F31503"
            }}
          >
            <Videos videos={videos} />
          </span>

        </Typography>
      </Box>
    </Stack>
  )
}

export default Feed